import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { AccessRequired } from 'src/components/AccessRequired'
import { NotFound } from 'src/components/NotFound'

import { ClientLayout } from './layout'
import {
  ASNListPage,
  ASNPage,
  DashboardOSandDPage,
  DamagedListPage,
  DamagedPage,
  FacilityListPage,
  FacilityPage,
  HomePage,
  PalletListPage,
  PalletPage,
  SettingsPage,
  SkuListPage,
  SkuPage,
} from './pages'
import { FreightRouter } from './freightRoutes'
import { ParcelRouter } from './parcelRoutes'

export const ClientRouter = () => {
  return (
    <ClientLayout>
      <AccessRequired>
        <Switch>
          <Route path="/" component={HomePage} exact />
          <Route path="/dashboards/os&d" component={DashboardOSandDPage} exact />
          <Route path="/settings" component={SettingsPage} exact />
          <Route path="/facilities" component={FacilityListPage} exact />
          <Route path="/facilities/:guid" component={FacilityPage} exact />
          <Route path="/inventory/skus/:guid" component={SkuPage} exact />
          <Route path="/inventory/skus" component={SkuListPage} exact />
          <Route path="/inventory/damages/:guid" component={DamagedPage} exact />
          <Route path="/inventory/damages" component={DamagedListPage} exact />
          <Route path="/pallets/:guid" component={PalletPage} exact />
          <Route path="/pallets" component={PalletListPage} exact />
          <Route path="/asn/:guid" component={ASNPage} exact />
          <Route path="/asn" component={ASNListPage} exact />
          <Route path="/freight" component={FreightRouter} />
          <Route path="/parcel" component={ParcelRouter} />
          <Route path="*" component={NotFound} />
        </Switch>
      </AccessRequired>
    </ClientLayout>
  )
}
